import React from "react";
import { useParams } from "react-router-dom";
//#region types
import { EntityIdParams } from "models/propTypes/urlParamsTypes";
import { WintSuperkollAPIModelAccounting } from "wint-api-client/dist/types";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { LoadingWithLogo, PageLayouts, RouteBreadCrumb, useMountedState } from "components/common";
import { ErrorView } from "components/error";
import VoucherDetailsView from "./detailsView";
import { useVoucherService } from "serviceHooks";
import useVoucherPermissions from "./usePermissions";
//#endregion

const VoucherView: React.FC = () => {
  const voucherService = useVoucherService();
  const [loading, setLoading] = React.useState(true);
  const [voucher, setVoucher] = React.useState<WintSuperkollAPIModelAccounting.Voucher>();
  const { getMounted } = useMountedState();

  const urlParams = useParams<EntityIdParams>();
  const loadVoucher = (voucherId: string) => {
    if (voucher?.id !== voucherId) {
      setLoading(true);
      voucherService
        .getVoucher(voucherId)
        .then((res) => {
          if (getMounted()) {
            setVoucher(res);
          }
        })
        .finally(() => setLoading(false));
    }
  };

  React.useEffect(() => {
    const voucherId = urlParams.id;
    if (voucherId) {
      loadVoucher(voucherId);
    } else {
      setVoucher(undefined);
      setLoading(false);
    }
  }, [urlParams]);

  const { getCanView } = useVoucherPermissions();
  const canView = getCanView();

  return (
    <PageLayouts.EntityFullScreen
      id={voucher?.number ?? 0}
      entityKey={`voucher`}
      navigation={
        <RouteBreadCrumb current={loading ? "" : voucher?.text ?? TranslationKeys.Accounting.ManualPayment} showHome />
      }
      hasPermissions={canView}
    >
      {loading ? <LoadingWithLogo /> : voucher ? <VoucherDetailsView voucher={voucher} /> : <ErrorView />}
    </PageLayouts.EntityFullScreen>
  );
};

export default VoucherView;
